module.exports = __webpack_public_path__ + "img/uon.c5b51e78.png";